import React, { createContext, useContext, useMemo, useState } from 'react';

export const SidebarContext = createContext<any>(null);

export const CANCEL_SELF_INSPECTIONS = 'SELF_INSPECTIONS';

const SidebarProvider = ({ ...props }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(0);
  const [isStepper, setIsStepper] = useState(false);
  const [stepperTitle, setStepperTitle] = useState('');
  const [step, setStep] = useState(0);
  const [recentCancel, setRecentCancel] = useState('');

  const authDataValue = useMemo(
    () => ({
      open,
      setOpen,
      isStepper,
      setIsStepper,
      stepperTitle,
      setStepperTitle,
      selected,
      setSelected,
      recentCancel,
      setRecentCancel,
      step,
      setStep
    }),

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [open, isStepper, stepperTitle, selected, step],
  );

  return <SidebarContext.Provider value={authDataValue} {...props} />;
};

export const useSidebarContext = () => useContext(SidebarContext);

export default SidebarProvider;
